import React, { useState, useEffect } from "react";
import { UseBrand } from "./UseBrand";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";

export default function BrandAutoComplete(props) {
  const { getAllBrandList } = UseBrand();
  const [brandRes, setBrandRes] = React.useState();
  const [selectedBrand, setSelectedBrand] = React.useState();

  useEffect(() => {
    getAllBrandList((brands) => {
      setBrandRes(brands);
    });
  }, []);

  useEffect(() => {
    if (!props.selectedBrandID) {
      setSelectedBrand();
    }
  }, [props.selectedBrandID]);

  useEffect(() => {
    if (brandRes && props.selectedBrandID) {
      setSelectedBrand(
        brandRes.brands.find((m) => m.id == props.selectedBrandID)
      );
    }
  }, [brandRes, props.selectedBrandID]);

  useEffect(() => {
    if (selectedBrand) {
      if (props.Gift) {
        props.setter({
          ...props.lvl1State,
          brandID: selectedBrand.id,
          productID: undefined,
          groupID: undefined,
          minCost: 0,
          maxCost: 0,
          giftID: undefined,
        });
        return;
      }
      if (props.Offer) {
        props.setName(selectedBrand.faName);
      }

      props.setter({
        ...props.lvl1State,
        brandID: selectedBrand.id,
      });
    }
  }, [selectedBrand]);

  return brandRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.Offer && "100%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedBrand ? selectedBrand : ""}
        options={brandRes.brands ? brandRes.brands : []}
        getOptionLabel={(brands) => (brands.faName ? brands.faName : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.validation} {...params} label="برند" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedBrand(newValue);
          } else {
            setSelectedBrand();
            props.setter({
              ...props.lvl1State,
              brandID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllBrandList((brands) => {
            setBrandRes(brands);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/brands" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
